import React, { useState, useEffect } from 'react'
import Webcam from 'react-webcam'
import { Buffer } from 'buffer'
import { Typography, Button, Container, Box } from '@mui/material'
import { CameraFront } from '@mui/icons-material'

export const WebcamComponent = (props: any) => {
  const {
    onReTake,
    onImageCapture,
    isEnabled = false,
    action = 'upload',
    isFaceMatchingInProgress,
    fromProjectPhotos,
  } = props
  const [enableWebcam, setEnableWebcam] = useState<boolean>(false)
  const [imageSrc, setImageSrc] = useState<string | null>(null)
  const [counter, setCounter] = useState(5)
  const [hasWebCamPermissions, setHasWebCamPermissions] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const videoConstraints = {
    width: 420,
    height: 420,
    facingMode: 'user',
  }
  const webcamRef: any = React.useRef(null)

  const capture = React.useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      if (stream) {
        const imageSrc = webcamRef.current.getScreenshot()
        setHasWebCamPermissions(true)
        const imageFile = dataURLtoFile(imageSrc, 'capture.jpeg')
        if (action === 'compare') {
          //const imageBuffer = dataURLtoBuffer(imageSrc);
          //const imageFile = dataURLtoFile(imageSrc, 'capture.jpeg')
          onImageCapture(imageFile)
        } else {
          //const imageFile = dataURLtoFile(imageSrc, 'capture.jpeg')
          onImageCapture(imageFile)
        }
        setImageSrc(imageSrc)
        setEnableWebcam(false)
      }
    } catch (error: any) {
      console.error(error, 'error')
      if (error.name === 'NotAllowedError' || error.name === 'NotFoundError') {
        const message =
          'Webcam access is diabled in your browser. Please go to settings and enable it.'
        setErrorMessage(message)
      } else {
        setHasWebCamPermissions(false)
        console.error('Error accessing webcam:', error)
        setErrorMessage(error.message)
      }
    }
  }, [webcamRef, action, onImageCapture])

  const dataURLtoFile = (dataurl: any, filename: any) => {
    if (dataurl) {
      const arr = dataurl?.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const base64Decoded = Buffer.from(arr[1], 'base64')
      let n = base64Decoded.length
      const u8arr = new Uint8Array(n)
      for (let i = 0; i < n; i++) {
        u8arr[i] = base64Decoded[i]
      }
      return new File([u8arr], filename, { type: mime })
    }
  }

  const dataURLtoBuffer = (dataurl: any) => {
    const arr = dataurl?.split(',')
    const base64Decoded = Buffer.from(arr[1], 'base64')
    return base64Decoded
  }

  const retake = () => {
    setImageSrc(null)
    setEnableWebcam(true)
    if (onReTake) onReTake()
    setCounter(5)
    if (!fromProjectPhotos) {
      capture()
    }
  }

  const stop = () => {
    if (webcamRef.current && webcamRef.current.video.srcObject) {
      const videoTracks = webcamRef.current.video.srcObject.getVideoTracks()
      videoTracks.forEach((track: any) => track.stop())
      // This line ensures that the srcObject is set to null, effectively turning off the webcam
      webcamRef.current.video.srcObject = null
    }
  }

  const checkCameraPermission = async () => {
    let stream = await navigator.mediaDevices.getUserMedia({ video: true })
    counter > 0 && stream && setTimeout(() => setCounter(counter - 1), 1000)
    if (counter === 0) {
      capture()
    }
  }

  useEffect(() => {
    if (enableWebcam) {
      checkCameraPermission()
      // counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
      // if (counter === 0) {
      //   capture()
      // }
    } else {
      stop()
    }
  }, [enableWebcam, counter, capture])

  useEffect(() => {
    setEnableWebcam(isEnabled)
  }, [isEnabled])

  return (
    <>
      {!fromProjectPhotos && (
        <Typography variant='h6' gutterBottom sx={{ ml: 4 }}>
          {'Face ID:'}
        </Typography>
      )}
      <Container
        maxWidth={fromProjectPhotos ? 'xl' : 'lg'}
        sx={{
          mb: fromProjectPhotos ? 0 : 3,
          position: 'relative',
          ...(fromProjectPhotos ? { padding: '0 !important' } : {}),
          ...(fromProjectPhotos ? { height: '360px' } : { height: 100 + '%' }),
        }}
        style={{ width: '100%' }}>
        {!enableWebcam && !imageSrc ? (
          <>
            <Box
              style={{
                height: 420,
                backgroundColor: 'rgba(51, 51, 51, 0.11)',
              }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: 100 + '%',
                }}>
                <Button sx={{ mt: 3 }} onClick={() => setEnableWebcam(true)}>
                  Open Camera <CameraFront sx={{ ml: 2 }} />
                </Button>
              </Box>
            </Box>
          </>
        ) : !imageSrc ? (
          <>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat='image/jpeg'
              videoConstraints={videoConstraints}
              style={{
                width: 100 + '%',
                ...(fromProjectPhotos
                  ? { borderRadius: '8px', overflow: 'hidden' }
                  : {}),
              }}
            />
            <div>Countdown: {counter}</div>
            {counter === 0 ? errorMessage && <div>{errorMessage}</div> : null}
          </>
        ) : (
          <>
            <img
              src={imageSrc}
              style={{
                ...(fromProjectPhotos
                  ? { borderRadius: '8px', overflow: 'hidden' }
                  : {}),
              }}
              alt='worker face'
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                marginTop: fromProjectPhotos ? 0 : 10 + 'px',
              }}>
              <Button
                onClick={() => retake()}
                disabled={isFaceMatchingInProgress}>
                Retake <CameraFront sx={{ ml: 2 }} />
              </Button>
            </Box>
          </>
        )}
      </Container>
    </>
  )
}
